import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import Card from '../../card/card-component';
import { GET_BIO_HOME } from '../biographies/apis';
import Skeleton from '@material-ui/lab/Skeleton';
import noPostsFound from '../../homepage/images/no-posts.svg';

import {Button } from '@material-ui/core';
import { Container, Row, Col } from 'react-bootstrap';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

export default function LatestBiographies() {

    const { loading, error, data , refetch} = useQuery(GET_BIO_HOME, { variables: { is_Draft: false } });
    useEffect(()=>{
        refetch();
    },[]);
    if (error) return `Error! ${error.message}`;
    if (loading) {
        return (
            <container>
                <Row className="pt-5 m-0">
                    <Col md={10} className="pb-3">
                        <Skeleton variant="text" width={150} />
                    </Col>
                    <Col md={3}>
                        <Skeleton variant="rect"  height={200} />
                    </Col>
                    <Col md={3}>
                        <Skeleton variant="rect"  height={200} />
                    </Col>
                    <Col md={3}>
                        <Skeleton variant="rect"  height={200} />
                    </Col>
                    <Col md={3}>
                        <Skeleton variant="rect"  height={200} />
                    </Col>
                </Row>
            </container>
        )
    }
    else {
         let bio = data.me.biosYours?.data;
        // let bio;
        let size = 4;
        console.log(bio);
        if (!bio.length > 0) {
            return (
                <container>
                    <Row className="pt-5 m-0">
                        <Col md='12'  className="text-center pt-2 ">
                            <div className="pt-3 pb-3">
                                <img src={noPostsFound} alt="No Posts" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="text-grey">You've no visumes yet</p>
                            </div>
                            <div>
                                <Link 
                                    onClick={e=>{
                                        window.scrollTo({ top: 0, behavior: 'smooth' })
                                        }} to="/createVisume">
                                    <Button  size="large" varient="outlined" className="btn-orange-gradiant text-white pr-5 pl-5">Create Visume</Button>
                                </Link>
                            </div>
                        </Col>
                        
                    </Row>
                </container>
            )
        } else {
            return (
                <Container>
                    <Row className="pt-5 m-0">
                        <Col sm={6} xs={12} className="pb-3 pl-0 pb-0-responsive">
                            <h5><Link className="text-dark" to='/visumes'>Your Visumes</Link></h5>
                        </Col>
                        <Col className="text-right pb-3 pr-0" sm={{ span: 4, offset: 2 }} xs={12}>
                            <button
                                className="bg-transparent border-0"
                                onClick={e => localStorage.setItem('updatedBio', '')}>
                                <h5><Link className="text-orange" to='/visumes'>See All <ArrowForwardIcon /></Link></h5>
                            </button>
                        </Col>
                    </Row>
                    <Row className="justify-conent-center align-items-center">
                        {
                            bio?.slice(0, size).map(item =>
                                <Card key={item.id} data={item} />
                            )
                        }
                    </Row>
                </Container>
            );
        }
    }
}